<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_table_of_contents_1"><span>Dog Days</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By TA Moore</p>
<p class="P_Normal"> </p>
<p class="P_Normal">The world ends not with a bang, but with a downpour. Tornadoes spin through the heart of London, New York cooks in a heat wave that melts tarmac, and Russia freezes under an ever-thickening layer of permafrost. People rally at first—organizing aid drops and evacuating populations—but the weather is only getting worse.</p>
<p class="P_Normal">In Durham, mild-mannered academic Danny Fennick has battened down to sit out the storm. He grew up in the Scottish Highlands, so he’s seen harsh winters before. Besides, he has an advantage. He’s a werewolf. Or, to be precise, a weredog. Less impressive, but still useful.</p>
<p class="P_Normal">Except the other werewolves don’t believe this is any ordinary winter, and they’re coming down over the Wall to mark their new territory. Including Danny’s ex ex, Jack—the Crown Prince Pup of the Numitor’s pack—and the prince's brother, who wants to kill him.</p>
<p class="P_Normal">A wolf winter isn’t white. It’s red as blood.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?a2bb3b48